import TeamAccountLogin from './TeamAccountLogin';

export default TeamAccountLogin;
